import logo from '../assets/logo.png'; // Add your logo to assets folder


const Header = ({ language, onLanguageChange }) => {


  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Restaurant Logo" className="logo" />
      </div>
      {/* <div className="language-selector">
        <select 
          value={language} 
          onChange={(e) => onLanguageChange(e.target.value)}
          className="language-dropdown"
        >
          <option className='option' value="en">English</option>
          <option value="ar">العربية</option>
          <option value="ku">کوردی</option>
        </select>
      </div> */}
    </header>
  );
};

export default Header;